import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import  PlansSears  from "../organisms/PlansSears";
import { validateUserAgent } from "../organisms/utils"
import ModalCardOk from '../molecules/ModalCardOk'
import * as sdkclaro from '@claropay/claro-pay-sdk-v2';
 import {
  setCodeError
} from '../../store/actions';

const Container = styled.div`
  width: 100%;
  overflow: scroll;
  background: #f6f6f6;
  padding: ${props => validateUserAgent() === "android" ? "0px 0px .5em 0px" : "0px 0px 2em 0px"};
`;

class SearsContainer extends Component {
    
    constructor(props) {
        super(props)
        this.state = {
          lowerLimit: 0,
          upperLimit: 5,
          isloading: false,
          planSelected: [],
          showTooltipAmountDetail: false,
          marginBottomPagination: validateUserAgent() === "android" ? "24vh" :"29vh",
          inputValues: [],
          amount: 0,
          openAlert: false,
          setOpenValue: true,
          openModalGoToHome: false,
          firstRender: false,
          changeInputValue: false,
          paymentCard: {},
          clickInput: false
        }
    }

    componentDidMount() { 
      this.setState({firstRender: true})
    }
    
    marginBottomCalculate = (handleInputClick) => {
      const { showTooltipAmountDetail } = this.state;
      const isAndroid = validateUserAgent() === "android";
     
      if (handleInputClick) {
        return showTooltipAmountDetail ? (isAndroid ? "45vh" : "28vh") : (isAndroid ? "33vh" : "20vh");
      }
      return showTooltipAmountDetail ? (isAndroid ? "24vh" : "29vh") : (isAndroid ? "33vh" : "37vh");
    }

    getPlansAmountValues = () =>{
      const { paymentPlans, accountDetails } = this.props.existCardSearsValue;   
      // console.log(paymentPlans, 'details')
      let paymentCard = {
        accountNumber: accountDetails.accountNumber,
        paymentSegment: []
      };   
      let { inputValues } = this.state
      if(inputValues.length === 0){
        paymentPlans.map(function(plan, key) {
          // inputValues[key] = plan.monthlyPaymentAmount;
          inputValues[key] = plan.minimumPaymentAmount;
          paymentCard.paymentSegment = [
			      ...paymentCard.paymentSegment,
            {
              segmentId: parseFloat(plan.payPlanNumber).toString(),
              sequence: parseFloat(plan.sequence).toString(),
              // segmentAmount: parseFloat(plan.monthlyPaymentAmount).toString()
              segmentAmount: parseFloat(plan.minimumPaymentAmount).toString()
            }            
          ]
        })     
        this.state.paymentCard = paymentCard;
      }
    }

    onChangePagination = (current, pageSize)=>  {
      let upperLimitValue = current * pageSize;
      let lowerLimitValue =  upperLimitValue - pageSize;
      this.setState({
        upperLimit: upperLimitValue ,
        lowerLimit: lowerLimitValue,
        isloading: false
      })

      setTimeout(
        function(){ 
          this.setState({isloading: false})
        }.bind(this), 
        1000
      );
    }
    handleOnblur = (event, key) => {
      this.setState({
        clickInput: false, 
      })
    }

    handleOnClickCardInfo = (event, plan ) => {
      const { inputValues, changeInputValue } = this.state
      const { accountDetails } = this.props.existCardSearsValue
      let amount = 0;
      if(changeInputValue){
        inputValues.map(function(value) {
          amount += parseFloat(value) 
        })
      } else {
        amount = accountDetails.minimumToPay;
      }

      this.setState({
        planSelected:plan, 
        amount: parseFloat(amount)
      });    
    }

    handleOnClickAmountDetail = () => {
      if(this.state.showTooltipAmountDetail){
        this.setState({
          showTooltipAmountDetail: false, 
          marginBottomPagination: this.marginBottomCalculate(false)
        });
      }else{
        this.setState({
          showTooltipAmountDetail: true, 
          marginBottomPagination: this.marginBottomCalculate(false)
        });
      }
    }

    handleOnChangeInput = (event, key, plan ) =>{
      let { inputValues, paymentCard } = this.state
      const {value} = event.target
      const floatValue = parseFloat(value.replace(/[^0-9]/g, '') / 100);
      inputValues[key] = floatValue
      paymentCard.paymentSegment[key].segmentAmount = String(floatValue)

      this.setState({
        inputValues:inputValues, 
        //amount: event.target.value,
        amount: floatValue, 
        firstRender: false,
        changeInputValue: true,
        paymentCard: paymentCard
      })

      setTimeout(() => {
        this.handleOnClickCardInfo(event, plan)
      }, 500);
    }

    handleOnClickInput = (event) =>{
      event.stopPropagation()
      this.setState({
        marginBottomPagination: this.marginBottomCalculate(true),
        clickInput: true,
      }); 
    }

  onclickModal = () => {
      this.setState({openAlert:false});
      window.history.back();
  }

    render() {
     
      let {isLoadingExistCardSears, existCardSearsValue, errorExistCardSears, setCodeError} = this.props
      let {openModalGoToHome, setOpenValue} = this.state
      if(existCardSearsValue && existCardSearsValue.responseCode !== 0 && !isLoadingExistCardSears && setOpenValue){
        setCodeError(existCardSearsValue.codeError)
        window.history.back();
        // this.setState({openAlert: true, setOpenValue: false})
      }
      ///
      if(errorExistCardSears && errorExistCardSears.error && setOpenValue){
        this.setState({openModalGoToHome: true, setOpenValue: false});
      }
      if(existCardSearsValue && existCardSearsValue.responseCode === 0){
        if(existCardSearsValue.paymentPlans){
          this.getPlansAmountValues()
        } else {
          setCodeError('CP0005')
          window.history.back();
        }
      }
      return (
          <>
          <Container>
              {
                existCardSearsValue && existCardSearsValue.responseCode === 0 && existCardSearsValue.paymentPlans ? 
                  <PlansSears
                      plansSears = { this.props.existCardSearsValue }
                      titlePlansCardSears = {this.props.serviceDataInfo.titlePlansCardSears}
                      subtitlePlansCardSears = {this.props.serviceDataInfo.subtitlePlansCardSears}
                      onChangePagination = {this.onChangePagination}
                      upperLimit = {this.state.upperLimit}
                      lowerLimit = {this.state.lowerLimit}
                      handleOnClickCardInfo = {this.handleOnClickCardInfo}
                      handleOnClickInput = {this.handleOnClickInput}
                      planSelected = {this.state.planSelected}
                      showTooltipAmountDetail = {this.state.showTooltipAmountDetail}
                      handleOnClickAmountDetail = {this.handleOnClickAmountDetail}
                      marginBottomPagination = {this.state.marginBottomPagination}
                      handleOnChangeInput = {this.handleOnChangeInput}
                      inputValues = {this.state.inputValues}
                      sdkVersion = {this.props.sdkVersion}
                      isClaroPartner = {this.props.isClaroPartner}
                      paymentsConfig = {this.props.paymentsConfig}
                      amount={this.state.amount}
                      searsCardNumber = {this.props.searsCardNumber}
                      firstRender={this.state.firstRender}
                      paymentCard={this.state.paymentCard}
                      changeInputValue = {this.state.changeInputValue}
                      handleOnblur= {this.handleOnblur}
                      clickInput = {this.state.clickInput}
                  />: <></>

              }
            {
                <ModalCardOk
                isOpen={openModalGoToHome}
                srcImage="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAABBCAYAAACO98lFAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAQaADAAQAAAABAAAAQQAAAAD8l6BDAAAIi0lEQVR4Ae1ba4hVRRz/z727q67rqmhprpqPtDDCQNF8RGZl0GP9oBkWSVSYQgVZX/pQH6KPaWCBi1CBUpHZB7cXWZmQjxSLIpKSTMtHYkqurqvu457+v5k7c86ZPWf3PmauwvqDe8/858yd/+POzJnH7xBdBYlKxiDY9FCWBvw7lLKZwZSp7s+6+1EuU0OZXDunL1Gu4yJ15VrowjX/iSUfdVXKNq9BCD6fOZq6gvnszHwKxBwKaDxRkO3dOdHFf88hEsFOLruNsmKbuG/P0d5/V1oJ50EIvp03hM61PUwkHqMgmFOaWQm/EoIDEmykQbUfiju3n0koUXKWsyAEn8xqoCD3Ihu6nP/x2kSLRIao9jqigWOIagYTVXGxLPeKrotEnW1E7S1E548Qtf3D1eQSq+AWwgXFehKZ18WDu48lFyout+wgcJOvpw56la1eyaprYuozVUTDp4ef+huIx4JYkUQh10F09g+iU/vCT67TLsrjiFhH1fQKd5Wz9s1i5LKCEDTPWMrK1vA/PzKmdPBkorGNRKPvJaquj90qSUALObaV6O9mopYD8SoEneCMVaJx7wfxG4VLJQUh2Le8mo79tJbVrIipGthAdBNnNSyIZTsVEIzfmrjbdOsJTdRw63Ni+npuRsWh6CAEX981jNpaN/OgN8+oQv+e/ATR+MXcQrkL+EbAXePQZqID76hxROsTYjvV1i0Wd39zWmcVci0qCEHznJuJOpq5+U8wlY+5n+iWF3iQG2iyKpboPE/0y2qiI5+FKgX9yX2wUTTu/DXM7DlVcBCCLTPv4ao+5gFwkKwSI/2UZ4gmPtqzhkrcPfge0f63Ik8UcY7VLhIL93xViPqCgiBbQNC52wSguo5o2mtE184qREdlypzcRfTDy9xQW/P6OBCialYhLaLXIKgx4Nxe0wVqRxHd9gZR3bjKOFeMltbDRN8/z/OM4+pX6Bq1g2b0NkZwm06HfArIQTA/BqAFuAoA5gId/HjXHwx25QJ/DOyDnQDGLrZf+qFyEr97bAnBlhnr+FfqMYgxYOZq7gKzEysqKrPld6Ldz8ZHdjxhZnO/ruc5RrlA19jDg3U462wSC/diMpeI1JaQnwiF84ApbLSLAMCMkzy8YAIUBeQTO6I5padhJwbtECvy/oQ5kVRiEORUGDNBDTwGJz6ipfKvaVPnbL/y69Y14KkFu0OsyfsV5uRTiUGQawE9FUYzxTzAJdLmFGn5peqG3bAfgD9yjaPE6He3IMjVoFoMqXI3Pul+IoTVYxLS8pPKFpKHoMJ+g2Cl8s9kyES3IKjlcH41iLXAuEXxX7iQqlNml2n55eiE/fBDoSbvn5blNRaE4NO5Q7ndLDclsBjysRZIa/Zp+cagEhKwH34YBMvlxo+ReXUfSRPl2pdw31FtFcthX6vBNGfT8mNGliDAD/gDwD+586VEfMeDENAyc+v6hSbpPJHmbFq+CwOwv2HAW38RmCDITVGersh72BHy1QqgIM3ZtPyIwSUnscEDvwDe+8z7K0UThPyusMyUW2IudoRUbd2/0wbAtPzuNRSfA3+w1aehdsGlFAYB2+Ia0cI6z+UVg5U9YYLsYxCO2h33y/gbBgHnAhrxwjrX7dX+123ZrTZV2/BpYa0Rf2UQ5MmQPBjhMlgoYVfYN+z+b8s+9NdPUv6hbvaXH5VykFAtAUdj+mQI5wJ2U/VhkO20LfvQCb/gnwSfhLXRcCRVEHA2qIGDkUrAdtqWfdkQ9a9LDIMaFYRc1QCjUy84TIanhO20LXtSaxZUqD+r/FZBqBI1RqfrRYyp2ErYemzZKu5MjOrJBP1Rb74l8PG4Bs4GKwH7aWDLvmyI+pepln6rICh+gFKLw9FKwG7+tuzLhqh/uY52qFFBAEFCA6fDlUC0WUKfLfuyIepfpusC1OS7AzNENOy9P53v+mr/87bsWp+uL+rfJZJ+qyCAIqMBfkAlYI8BtuzLhqh/2eA01KggMEeIp1JdUi8IEjgT8I2stcVWiZYAv+CfBPtbS6eQlEGQJClwhADs1YMg4Rv6gETrqUQQ4Jc+i2B/mfYjT3xUS4AhiiSlTAJDxDdsp23Zh/6oXxF/wyCAJaYRLazzXF9tp23ZtT7UF/fL+BsGgWlyRi8K44zQJ/rxmg0rVgBXyD4Bf6JBiPhrgpDnCe6SdoAkBVqMT9QM4V3gp9UGKK6QfeLolzzgyyGAgy52RnmRJghSv6ANxo6/tpikt8Skx4nu2EiEq2+A9GXAfMgI4kHI1GxSPEEuAZaY79YQMcRrEn7AHwA8SCaEKkF9x4IgHtiB+cJ6UwAsMRe8AVPhZUjAfvhhINbbjNhYEGQ5ZorytV2mQZMDS8wXzjC3Cgb6bHGwP6T7tYMJa7vTLQiKKstMUQ3Q5MASc43TPxJ99xTT8N5VXKP9a11rUHbDfgOxLokK3C0IsjxTZbnvnJBpLDhAk3MNjNZ69oa6j3zhWoOyWy+Y4A/8SkBiEPJc4VWmPHiCoMm5RO3IeG0DRsTlciXYG+U3gvqbwoFODAL057nC4YgCniBoNq4wYSnRiLmsiE2oG0s09SVXNSs7YW+Ipp64zz0Tt8BhPv7zVkPhxaLn9rfd0vcwers8eWo9zGMNEzM0nxFU31FTF/TEee4xCAhkn+cxIgiKCFnN59qSKquIkog0aHJXEmAP7NJETmkvc5wLIHv32hK0n8ncZqb1uWS1aWXFXg++z9zmNyNPGw/cZm1Tn2e5m0Ckve8AlhhIUi4HOa3UvmIwvVzvO2hb+vybLzoQuPb4DhQ4T6D8uGC8YEMEM8wr6R2oWCD6+ttwsWD05fcio4FAWhJCFR9yGYuz7ftlyLt4Ubfhin5DNsk5SZPri+9KJwVD50mOECgyYIiAIAF+AI7HcTqcE/zGfOcFwtEYnwzpgxH926tXzxH4H5XW3qAaXYTFAAAAAElFTkSuQmCC"
                text={"¡Lo sentimos!"}
                buttontext={"Ok"}
                textdetail={"Por el momento este servicio no está disponible. Por favor, intenta más tarde."}
                onclickModal={(e) =>{sdkclaro.getInstance().closeMicroFront();}}
                fontSizeDetail="12px"
            />
            }
              
          </Container>
          </>
      )
    }
}

function mapStateToProps(state) {
  return {
    isLoadingExistCardSears: state.payments.isLoadingExistCardSears,
    existCardSearsValue: state.payments.existCardSears,
    errorExistCardSears: state.payments.errorExistCardSears,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setCodeError
    },
    dispatch,
  );
}

SearsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SearsContainer);

export default SearsContainer